export const liveUrl = "https://bestproperties.soursap.in/";
// export const liveUrl = "https://reactapi.guruhomesolutions.com/";
 
export const token = "9j1h8hgjO0KUin2bhj58d97jiOh67f5h48hj78hg8vg5j63fo0h930"; 
